if (window.location.pathname === '/blogs') {
    // Redirect to the main blog (you can replace 'your-blog-handle' with your actual blog handle)
    window.location.replace('/blogs/your-blog-handle');
}

document.addEventListener("DOMContentLoaded", function() {
  console.log("🟢 Variant switcher loaded");

  // Global delegated event listener for dropdown changes
  document.body.addEventListener("change", async function(e) {
    const dropdown = e.target.closest(".variant-option-dropdown");
    if (!dropdown) return; // Ignore unrelated changes

    const newVariantId = dropdown.value;
    if (!newVariantId) return;

    const cartItemRow =
      dropdown.closest("tr[data-product-id]") ||
      dropdown.closest(".product-cart-item[data-product-id]");
    if (!cartItemRow) return;

    const currentKey = cartItemRow.dataset.productId;
    const currentQuantityInput = cartItemRow.querySelector("input.qty");
    const currentQuantity = currentQuantityInput
      ? parseInt(currentQuantityInput.value)
      : 1;

    // Get available quantity from option
    const selectedOption = dropdown.querySelector(`option[value="${newVariantId}"]`);
    const availableQty = selectedOption ? parseInt(selectedOption.dataset.qty) : 0;

    // Determine quantity to add (cannot exceed available)
    const quantityToAdd = Math.min(currentQuantity, availableQty);

    if (quantityToAdd <= 0) {
      alert("❌ Selected variant is sold out or not enough stock.");
      dropdown.value = ""; // reset dropdown
      return;
    }

    // console.log("🔹 Current variant:", currentKey);
    // console.log("🔹 New variant:", newVariantId);
    // console.log("🔹 Cart quantity:", currentQuantity);
    // console.log("🔹 Available quantity:", availableQty);
    // console.log("🔹 Quantity to add:", quantityToAdd);

    dropdown.disabled = true;

    try {
      // Update cart: remove old variant, add new variant with correct quantity
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates: {
            [currentKey]: 0,
            [newVariantId]: quantityToAdd
          }
        })
      });

    //   console.log("✅ Variant updated — refreshing cart…");

      // Trigger global cart refresh for AJAX-based themes
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true })
      );

    } catch (err) {
      console.error("❌ Error updating variant:", err);
    } finally {
      dropdown.disabled = false;
    }
  });
});